import isEmpty from "../../is-Empty";
import validator from "validator";

export const RestaurantKYCDetailsValidation = (data) => {
  let errors = {};
  data.bankName = !isEmpty(data.bankName) ? data.bankName : "";
  data.accountNumber = !isEmpty(data.accountNumber) ? data.accountNumber : "";
  data.branchName = !isEmpty(data.branchName) ? data.branchName : "";
  data.ifscCode = !isEmpty(data.ifscCode) ? data.ifscCode : "";

  if (validator.isEmpty(data.bankName)) {
    errors.bankName = "Bank name is required";
  }
  if (validator.isEmpty(data.accountNumber)) {
    errors.accountNumber = "Account number is required";
  }
  if (validator.isEmpty(data.branchName)) {
    errors.branchName = "Branch name is required";
  }
  if (validator.isEmpty(data.ifscCode)) {
    errors.ifscCode = "IFSC code is required";
  }

  return {
    errors,
    isValid: isEmpty(errors),
  };
};

export const RestaurantKYCDetailsValidationTwo = (data) => {
  let errors = {};

  data.gstNumber = !isEmpty(data.gstNumber) ? data.gstNumber : "";
  data.fssaiCode = !isEmpty(data.fssaiCode) ? data.fssaiCode : "";
  data.panCard = !isEmpty(data.panCard) ? data.panCard : "";
  data.kyc_photo = !isEmpty(data.kyc_photo) ? data.kyc_photo : "";

  if (validator.isEmpty(data.gstNumber)) {
    errors.gstNumber = "GST number is required";
  }
  if (validator.isEmpty(data.fssaiCode)) {
    errors.fssaiCode = "FSSAI code is required";
  }
  if (validator.isEmpty(data.panCard)) {
    errors.panCard = "PAN card is required";
  }

  //   if (validator.isEmpty(data.kyc_photo)) {
  //     errors.kyc_photo = "Document photo is required";
  //   }

  return {
    errors,
    isValid: isEmpty(errors),
  };
};
